import {
  AdditionalFieldType,
  AdditionalFieldWithLabel,
} from "@boark/shared/types/additional-field";

import { formatDate } from "../utils/date";
import { stringToInt } from "../utils/string-to-number";

export function parseFormValuesToAdditionalFields(
  values: Record<string, string>,
  additionalFields: AdditionalFieldWithLabel[],
  nullish = false,
): Record<string, unknown> {
  return Object.keys(values).reduce(
    (acc: Record<string, unknown>, key: string) => {
      const value = values[key] ?? "";
      const field = additionalFields.find((field) => field.name === key);

      if (value.trim() === "") {
        if (nullish) {
          return {
            ...acc,
            [key]: null,
          };
        }
        return acc;
      }

      if (!field) {
        throw new Error(`Additional field ${key} not found`);
      }

      let parsedValue: unknown;
      switch (field.type) {
        case "text":
        case "date":
        case "select":
          parsedValue = value;
          break;
        case "number":
          parsedValue = stringToInt(value);
          break;
        case "boolean":
          parsedValue = value === "1";
          break;
      }

      return {
        ...acc,
        [key]: parsedValue,
      };
    },
    {},
  );
}

export function parseAdditionalFieldToFormValue(value: unknown): string {
  if (typeof value === "string") {
    return value;
  } else if (typeof value === "number") {
    return value.toString();
  } else if (typeof value === "boolean") {
    return value ? "1" : "0";
  } else if (value instanceof Date) {
    return formatDate(value);
  } else if (value === undefined) {
    return "";
  }

  throw new Error("Invalid value");
}

export function additionalFieldDefaultFormValue(
  type: AdditionalFieldType,
): string {
  switch (type) {
    case "text":
    case "date":
    case "select":
      return "";
    case "boolean":
    case "number":
      return "0";
  }
}
